import CRMSectionOptions from "./CRMSectionOptions";
import DatabaseSectionOptions from "./DatabaseSectionOptions";
import FinanceSectionOptions from "./FinanceSectionOptions";
import SettingsSectionOptions from "./SettingsSectionOptions";

export const ManageRolesConsts = {
  arrowPosition: "right",
  borderedValue: false,
  DASHBOARD_LABEL: "Dashboard",
  DASHBOARD_NAME: "dashboard",
  ROLE_NAME_LABEL: "Role Name",
  ROLE_NAME_NAME: "roleName",
  ROLE_NAME_PLACEHOLDER: "Enter Role Name",
  NONE_SELECTED_WARNING: "Need to select atleast one permission",
};

export const DatabasePermissions = [
  {
    label: "Customer Database",
    name: "cd",
  },
  {
    label: "Job Database",
    name: "jd",
  },
  {
    label: "Quarry Database",
    name: "qd",
  },
  {
    label: "Material Database",
    name: "md",
  },
  {
    label: "Owner Operator Database",
    name: "ood",
  },
  {
    label: "CDL Driver Database",
    name: "cdd",
  },
];

export const SettingsPermissions = [
  {
    label: "Bid Tool Configuration",
    name: "btc",
  },
  {
    label: "Rule Engine",
    name: "re",
  },
  {
    label: "Manage Roles",
    name: "mr",
  },
  {
    label: "System Users",
    name: "su",
  },
  {
    label: "Sales People",
    name: "sp",
  },
  {
    label: "System Settings",
    name: "ss",
  },
  {
    label: "Restore Database",
    name: "rd",
  },
  {
    label: "Image Database",
    name: "id",
  },
  {
    label: "Documents",
    name: "documents",
  },
];

export const SectionList = [
  {
    key: "CRM",
    label: "CRM",
    children: <CRMSectionOptions />,
  },
  {
    key: "DB",
    label: "Databases",
    children: <DatabaseSectionOptions />,
  },
  {
    key: "FN",
    label: "Finance",
    children: <FinanceSectionOptions />,
  },
  {
    key: "SS",
    label: "Settings",
    children: <SettingsSectionOptions />,
  },
];

export const buildPanelDataFromPermissions = (permissions, panelTemplate) => {
  const mapping = {
    dashboard: { panel: "Dashboard", option: "On" },
    tmEdit: { panel: "CRM", child: "Trucking & Material", option: "Edit" },
    tmView: { panel: "CRM", child: "Trucking & Material", option: "View" },
    tmInternalApproval: {
      panel: "CRM",
      child: "Trucking & Material",
      option: "Internal Approval",
    },
    ownerOperator: { panel: "CRM", child: "Owner Operator", option: "On" },
    cd: { panel: "Databases", child: "Customer Database", option: "On" },
    ood: { panel: "Databases", child: "Owner Operator Database", option: "On" },
    cdd: { panel: "Databases", child: "CDL Driver Database", option: "On" },
    qd: { panel: "Databases", child: "Quarry Database", option: "On" },
    md: { panel: "Databases", child: "Material Database", option: "On" },
    jd: { panel: "Databases", child: "Job Database", option: "On" },
    tuEdit: { panel: "Finance", child: "Ticket Upload", option: "Edit" },
    tuReview: { panel: "Finance", child: "Ticket Upload", option: "Review" },
    tpDataInput: {
      panel: "Finance",
      child: "Ticket Processing",
      option: "Data Input",
    },
    tpManagerReview: {
      panel: "Finance",
      child: "Ticket Processing",
      option: "Manager Review",
    },
    tpArchiveView: {
      panel: "Finance",
      child: "Ticket Processing",
      option: "Archived View",
    },
    tpArchiveEdit: {
      panel: "Finance",
      child: "Ticket Processing",
      option: "Archived Edit",
    },
    imView: { panel: "Finance", child: "Invoice Management", option: "View" },
    imEdit: { panel: "Finance", child: "Invoice Management", option: "Edit" },
    lmView: { panel: "Finance", child: "Lien Process", option: "View" },
    lmEdit: { panel: "Finance", child: "Lien Process", option: "Edit" },
    paView: { panel: "Finance", child: "Project Analysis", option: "View" },
    paEdit: { panel: "Finance", child: "Project Analysis", option: "Edit" },
    btc: { panel: "Settings", child: "Bid Tool Configuration", option: "On" },
    re: { panel: "Settings", child: "Rule Engine", option: "On" },
    mr: { panel: "Settings", child: "Manage Roles", option: "On" },
    su: { panel: "Settings", child: "System Users", option: "On" },
    sp: { panel: "Settings", child: "Sales People", option: "On" },
    ss: { panel: "Settings", child: "System Settings", option: "On" },
    rd: { panel: "Settings", child: "Restore Data", option: "On" },
    id: { panel: "Settings", child: "Image Database", option: "On" },
    documents: { panel: "Settings", child: "Documents", option: "On" },
  };

  const built =
    typeof structuredClone === "function"
      ? structuredClone(panelTemplate)
      : JSON.parse(JSON.stringify(panelTemplate));

  built.forEach((panel) => {
    panel.selectedOptions = [];
    panel.multiPannel?.forEach((child) => {
      child.selectedOptions = [];
    });
  });

  const parentMap = Object.fromEntries(built.map((p) => [p.title, p]));
  const childMap = {};
  built.forEach((panel) => {
    if (panel.multiPannel) {
      childMap[panel.title] = Object.fromEntries(
        panel.multiPannel.map((ch) => [ch.title, ch])
      );
    }
  });

  Object.entries(permissions).forEach(([key, value]) => {
    if (!value || !mapping[key]) return;
    const { panel: pTitle, child: cTitle, option } = mapping[key];
    if (cTitle) {
      const ch = childMap[pTitle]?.[cTitle];
      if (ch && !ch.selectedOptions.includes(option)) {
        ch.selectedOptions.push(option);
      }
    } else {
      const p = parentMap[pTitle];
      if (p && !p.selectedOptions.includes(option)) {
        p.selectedOptions.push(option);
      }
    }
  });

  built.forEach((panel) => {
    // New override logic: if this is the "Operations" panel, make all its subItems fully selected
    if (panel.title === "Operations") {
      panel.multiPannel?.forEach((child) => {
        // Use child.availableOptions or child.options or your known list
        const opts = child.availableOptions || child.options || [];
        child.selectedOptions = Array.from(new Set(opts));
      });

      // Also mark the parent as selected
      // panel.mainPannelSelected = false;

      // Optionally select parent-level options if they exist
      const topOpts = panel.availableOptions || panel.options || [];
      panel.selectedOptions = Array.from(new Set(topOpts));
    } else {
      // Default logic for non-Operations
      const hasChildSelected = panel.multiPannel?.some(
        (c) => c.selectedOptions && c.selectedOptions.length > 0
      );
      if (panel.selectedOptions.length > 0 || hasChildSelected) {
        panel.mainPannelSelected = true;
      }
    }
  });

  return built;
};

export const activeKeys = ["CRM", "DB", "FN", "SS"];
